import { useEffect } from 'react';
import { isToday } from 'date-fns';

import { useUserWarningMessage } from '@/hooks/useUserWarningMessage';
import { useUserPreferencesState } from '@/hooks/useUserPreferencesState';
import { useNotificationStore } from '@/stores/notificationstore';

const USER_WARNING_MESSAGE_TIME_MILLIS_PREFERENCES_KEY = 'userWarningMessageTimeMillis';

export default function UserWarningMessages() {
  const showNotification = useNotificationStore((state) => state.showNotification);
  const warningMessage = useUserWarningMessage();
  const [userWarningMessageTimeMillis, setUserWarningMessageTimeMillis] = useUserPreferencesState<number | undefined>(
    USER_WARNING_MESSAGE_TIME_MILLIS_PREFERENCES_KEY,
    undefined
  );

  useEffect(() => {
    function closeNews() {
      setUserWarningMessageTimeMillis(Date.now());
    }

    const showMessage = userWarningMessageTimeMillis === undefined || !isToday(new Date(userWarningMessageTimeMillis));

    if (warningMessage?.message && showMessage) {
      showNotification('warning', warningMessage.message, closeNews);
    }
  }, [warningMessage, setUserWarningMessageTimeMillis, showNotification, userWarningMessageTimeMillis]);

  return null;
}
